module.exports = __webpack_public_path__ + "static/media/slack_icon.2522dee8.png";